export function getIdFromYoutubeUrl(youtubeURL: string | URL): string {
	const url = new URL(youtubeURL);
	const hostname = url.hostname.replace(/^www\./u, "");

	if (hostname === "youtu.be") {
		return url.pathname.slice(1);
	}

	if (hostname !== "youtube.com") {
		throw new Error("Invalid YouTube URL: Unsupported hostname. Expected 'youtube.com' or 'youtu.be'.");
	}

	const videoId = url.searchParams.get("v");

	if (!videoId) {
		throw new Error("Invalid YouTube URL: No video ID found.");
	}

	return videoId;
}
